"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _material = require("@mui/material");

var _TreeItem = require("@mui/lab/TreeItem");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var classes = {
  components: {
    MuiAccordion: _objectSpread({}, _material.accordionClasses),
    MuiAccordionDetails: _objectSpread({}, _material.accordionDetailsClasses),
    MuiAccordionSummary: _objectSpread({}, _material.accordionSummaryClasses),
    MuiAutocomplete: _objectSpread({}, _material.autocompleteClasses),
    MuiBox: {
      root: "MuiBox-root"
    },
    MuiButton: _objectSpread({}, _material.buttonClasses),
    MuiButtonBase: _objectSpread({}, _material.buttonBaseClasses),
    MuiCard: _objectSpread({}, _material.cardClasses),
    MuiCardHeader: _objectSpread({}, _material.cardHeaderClasses),
    MuiCardContent: _objectSpread({}, _material.cardContentClasses),
    MuiCardActions: _objectSpread({}, _material.cardActionsClasses),
    MuiCardActionArea: _objectSpread({}, _material.cardActionAreaClasses),
    MuiDrawer: _objectSpread({}, _material.drawerClasses),
    MuiFab: _objectSpread({}, _material.fabClasses),
    MuiFormControlLabel: _objectSpread({}, _material.formControlLabelClasses),
    MuiGrid: _objectSpread({}, _material.gridClasses),
    MuiIcon: _objectSpread({}, _material.iconClasses),
    MuiInput: _objectSpread({}, _material.inputClasses),
    MuiInputAdornment: _objectSpread({}, _material.inputAdornmentClasses),
    MuiInputBase: _objectSpread({}, _material.inputBaseClasses),
    MuiListemItem: _objectSpread({}, _material.listItemClasses),
    MuiListemItemIcon: _objectSpread({}, _material.listItemIconClasses),
    MuiMenu: _objectSpread({}, _material.menuClasses),
    MuiMenuItem: _objectSpread({}, _material.menuItemClasses),
    MuiPaper: _objectSpread({}, _material.paperClasses),
    MuiSvgIcon: _objectSpread({}, _material.svgIconClasses),
    MuiTab: _objectSpread({}, _material.tabClasses),
    MuiTablSortLabel: _objectSpread({}, _material.tableSortLabelClasses),
    MuiTabs: _objectSpread({}, _material.tabsClasses),
    MuiTextField: _objectSpread({}, _material.textFieldClasses),
    MuiTooltip: _objectSpread({}, _material.tooltipClasses),
    MuiTypography: _objectSpread({}, _material.typographyClasses),
    MuiTreeItem: _objectSpread({}, _TreeItem.treeItemClasses)
  },
  states: {
    MuiDisabled: "Mui-disabled",
    MuiFocusVisible: "Mui-focusVisible",
    MuiSelected: "Mui-selected"
  }
};
exports.classes = classes;